'use client'
import React, { useState, useEffect } from 'react';

const Breadcrumb = ({ className = "text-center" }) => {
    const baseURL = process.env.NEXT_PUBLIC_FRONTEND_URL;
    const [breadcrumbs, setBreadcrumbs] = useState<any[]>([]);

    useEffect(() => {
        const generateBreadcrumbs = () => {
            const pathArray = window.location.pathname.split('/').filter((segment) => segment !== '');
            const mappedPathArray = pathArray.map((segment) => {
                if (segment === 'services') return 'what-we-do';
                if (segment === 'web') return 'web-development';
                if (segment === 'mobile') return 'mobile-app-development';
                return segment;
            });

            const breadcrumbItems = mappedPathArray.map((segment, index) => {
                const url = `${baseURL}/${mappedPathArray.slice(0, index + 1).join('/')}/`;
                return {
                    name: segment.charAt(0).toUpperCase() + segment.slice(1),
                    url: (index === 2) ? `${baseURL}${window.location.pathname}/` : url,
                };
            });

            // Adding "Home" as the first breadcrumb
            const homeBreadcrumb = {
                // name: "Home" ,
                name: <i className="fas fa-home"></i> ,
                url: baseURL + '/',
            };

            return [homeBreadcrumb, ...breadcrumbItems];
        };

        const breadcrumbsArray = generateBreadcrumbs();
        setBreadcrumbs(breadcrumbsArray);


    }, []);

    return (
        <div className="py-3 !sm:pt-4">
            <div className={`${className} text-lg`} >
                {breadcrumbs.map((breadcrumb, index) => (
                    <span key={index}>
                        <a href={breadcrumb.url}>{breadcrumb.name}</a>&nbsp;
                        {index < breadcrumbs.length - 1 && <span>&gt;</span>}&nbsp;
                    </span>
                ))}
            </div>
        </div>
    );
};

export default Breadcrumb;
